
import Vue from "vue";
import { HTTP } from '@/axios_api/http-common';
import * as XLSX from 'xlsx';
export default Vue.extend({
    props: ["height", "selectedProjectId"],
    data() {
        return {
            depthTimeData: { tableId: '', columns: [] } as { tableId: '', columns: { columnName: string; values: string[] }[] },
            search: "",
            actionFilter: "All",
            categoryFilter: "All",
            fields: [
                { key: 'ActivityName', label: 'Activity Name', class: 'text-center' },
                { key: 'PlanDepth', label: 'Plan Depth' },
                { key: 'PlanTime', label: 'Plan Time', class: 'text-center' },
                { key: 'CumulativePlanTime', label: 'Cumulative Plan Time', class: 'text-center' },
                { key: 'ActualDepth', label: 'Actual Depth', class: 'text-center' },
                { key: 'ActualTime', label: 'Actual Time', class: 'text-center' },
                { key: 'CumulativeActualTime', label: 'Cumulative Actual Time', class: 'text-center' },
            ],
            tableData: [
                {
                    ActivityName: '8',
                    PlanDepth: 'Rig Move / Rig Up',
                    PlanTime: '0',
                    CumulativePlanTime: '8',
                    ActualDepth: '8',
                    ActualTime: '0',
                    CumulativeActualTime: '8',
                },
            ]
        }
    },
    computed: {
        computedTableData(): Array<any> {
            if (this.depthTimeData.columns.length) {
                let arr = [];
                for (let i = 0; i < this.depthTimeData.columns[0].values.length; i++) {
                    if (i === 0) continue;
                    arr.push({
                        ActivityName: this.depthTimeData.columns[0].values[i],
                        PlanDepth: this.depthTimeData.columns[4].values[i],
                        PlanTime: this.depthTimeData.columns[5].values[i],
                        CumulativePlanTime: this.depthTimeData.columns[6].values[i],
                        ActualDepth: this.depthTimeData.columns[1].values[i],
                        ActualTime: this.depthTimeData.columns[2].values[i],
                        CumulativeActualTime: this.depthTimeData.columns[3].values[i],
                    })
                }
                return arr
            }

            return []
        },

        getHeader(): string {
            return "Depth Time Table for " + this.getProjectNameFromId(this.selectedProjectId)
        }
    },
    methods: {exportToExcel() {
            const exportData = this.computedTableData.map(row => ({
                "Activity Name": row.ActivityName,
                "Plan Depth": row.PlanDepth,
                "Plan Time": row.PlanTime,
                "Cumulative Plan Time": row.CumulativePlanTime,
                "Actual Depth": row.ActualDepth,
                "Actual Time": row.ActualTime,
                "Cumulative Actual Time": row.CumulativeActualTime
            }));

            const ws = XLSX.utils.json_to_sheet(exportData);

            // Calculate column widths based on data
            type ExportDataKey = "Activity Name" | "Plan Depth" | "Plan Time" 
                | "Cumulative Plan Time" | "Actual Depth" 
                | "Actual Time" | "Cumulative Actual Time";
            const columnWidths = Object.keys(exportData[0] || {}).map(key => {
                const typedKey = key as ExportDataKey;
                const maxLength = Math.max(
                key.length,
                ...exportData.map(row => (row[typedKey] ? String(row[typedKey]).length : 0))
                );
                return { wch: maxLength + 2 }; // Add some padding
            });

            // Apply column width
            ws['!cols'] = columnWidths;

            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Time Depth Table");

            const fileName = `Time_Depth_Table_${this.getProjectNameFromId(this.selectedProjectId)}.xlsx`;
            XLSX.writeFile(wb, fileName);
        },
        fetchData() {
            if (!this.selectedProjectId) return;
            HTTP.get(`analytics/query/timevsdepth/?projectId=${this.selectedProjectId}`)
                .then((response: any) => {
                    this.depthTimeData = response.data.data
                })
                .catch((error: any) => {

                })
        },

        getProjectNameFromId(id: any) {
            const project = this.$store.getters["projectModule/getProjectById"](id);
            return project && project.name ? project.name : "";
        },
    },
    mounted() {
        // this.fetchData()
    },
    watch: {
        selectedProjectId: {
            immediate: true,
            handler() {
                this.fetchData()
            }
        },
        // depthTimeData: {
        //     handler() {
        //         if (!this.depthTimeData.columns.length) {
        //             this.fetchData()
        //         }
        //     }
        // }
    }
})
